import { render } from "./AddLanguageModal.vue?vue&type=template&id=dda4593a&scoped=true"
import script from "./AddLanguageModal.vue?vue&type=script&lang=js"
export * from "./AddLanguageModal.vue?vue&type=script&lang=js"

import "../pages/languagePackage/language-package.scss?vue&type=style&index=0&id=dda4593a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda4593a"]])

export default __exports__